// extracted by mini-css-extract-plugin
module.exports = {"header":"_1u1SkZ","navigation":"_38n21Y","content":"_8pucPb","logo":"_3_zGAy","logoNavItem":"_2JU4yB"};